<template>
    <div class="content new-order form">
        <div class="row">
            <div class="col-7">
                <el-card>
                    <div style="display:flex" class="sales-title">
                        <h4 style="display:inline">Sales</h4>
                        <h4 style="order:2;margin-left:auto" class="sub">Effective Date : 15/03/2022</h4>
                        <h4 style="order:3" class="sub"><i class="tim-icons icon-notes"></i>Change History</h4>
                        <h4 style="order:4" class="sub"><i class="tim-icons icon-single-02"></i>Change Action</h4>
                    </div>
                    <div style="display:flex;justify-content:space-between">
                        <base-input label="Salesman" >
                            
                        </base-input>
                        <base-input label="Team Head" :disabled="true">
                            
                        </base-input>
                        <base-input label="Sale Head" :disabled="true">
                            
                        </base-input>
                        <base-input label="Pool Head" :disabled="true">
                            
                        </base-input>
                    </div>
                </el-card>
            </div>
            <div class="col-5">
                <el-card>
                    <el-descriptions :column='1' >
                        <el-descriptions-item label="Order No" > - </el-descriptions-item>
                        <el-descriptions-item label="Status" > Open </el-descriptions-item>
                        <!-- <el-descriptions-item label="Attn">{{contactPerson.Name}}</el-descriptions-item>
                        <el-descriptions-item label="Tel">{{contactPerson.Phone}}</el-descriptions-item>
                        <el-descriptions-item label="Fax">{{contactPerson.Fax}}</el-descriptions-item>
                        <el-descriptions-item label="Email">{{contactPerson.Email}}</el-descriptions-item> -->
                    </el-descriptions>
                    <el-descriptions :column='2' >
                        <el-descriptions-item label="Create By" > - </el-descriptions-item>
                        <el-descriptions-item label="Date" > - </el-descriptions-item>
                        <el-descriptions-item label="Update By" > Open </el-descriptions-item>
                        <el-descriptions-item label="Date" > Open </el-descriptions-item>
                        <!-- <el-descriptions-item label="Attn">{{contactPerson.Name}}</el-descriptions-item>
                        <el-descriptions-item label="Tel">{{contactPerson.Phone}}</el-descriptions-item>
                        <el-descriptions-item label="Fax">{{contactPerson.Fax}}</el-descriptions-item>
                        <el-descriptions-item label="Email">{{contactPerson.Email}}</el-descriptions-item> -->
                    </el-descriptions>
                </el-card>
            </div>
        </div>
        <div class="row">
            <div class="col-7">
                <el-card>
                    <h4>Contracting Party</h4>
                    <base-input label="Client Type" >
                        <el-select class="select-primary" size="large" placeholder="Client Type"
                            v-model="clientType" filterable style="width:45%">
                            <!-- <el-option v-for="option in companyList" class="select-primary"
                                :value="option.id" :label="option.name.en_US" :key="option.id">
                            </el-option> -->
                        </el-select>
                    </base-input>
                    <div style="display:flex" class="input-with-check-box advertiser-field" >
                        <base-input label="Advertiser" style="width:75%" :required="true">
                            <el-select class="select-primary" size="large" placeholder="Advertiser"
                                v-model="clientType" filterable style="width:100%">
                                <!-- <el-option v-for="option in companyList" class="select-primary"
                                    :value="option.id" :label="option.name.en_US" :key="option.id">
                                </el-option> -->
                            </el-select>
                            <div style="display:flex">
                                <span class="sub-info" style="margin-left:auto"><span class="dot"></span>Private</span>
                                <span class="sub-info"><span class="dot"></span>Tax 88</span>
                                <span class="sub-info"><span class="dot"></span>BR  31/12/2022</span>
                                <span class="sub-info"><span class="dot"></span>Tax 88</span>
                            </div>
                        </base-input>
                        <base-checkbox v-model="isNewClient" >New Client</base-checkbox>
                    </div>
                    <div style="display:flex;position:relative;top:-20px"> 
                        <span style="color:#c43337;font-size:11px"> Salesman has no permission</span>
                    </div>
                    <div style="display:flex" class="input-with-check-box" >
                        <base-input label="Agency" style="width:75%" :required="true">
                            <el-select class="select-primary" size="large" placeholder="Agency"
                                v-model="clientType" filterable style="width:100%">
                                <!-- <el-option v-for="option in companyList" class="select-primary"
                                    :value="option.id" :label="option.name.en_US" :key="option.id">
                                </el-option> -->
                            </el-select>
                            <div style="display:flex">
                                <span class="sub-info" style="margin-left:auto"><span class="dot"></span>4A</span>
                                <span class="sub-info"><span class="dot"></span>Tax 88</span>
                            </div>
                        </base-input>
                        <base-checkbox v-model="isNewClient" >Agency Discount</base-checkbox>
                    </div>
                    <div style="display:flex" >
                        <base-input label="Address Name" style="width:75%" :required="true">
                            <el-select class="select-primary" size="large" placeholder="Agency"
                                v-model="clientType" filterable style="width:100%">
                                <!-- <el-option v-for="option in companyList" class="select-primary"
                                    :value="option.id" :label="option.name.en_US" :key="option.id">
                                </el-option> -->
                            </el-select>
                        </base-input>
                    </div>
                    <div style="display:flex" >
                        <base-input label="Address" style="width:80%" :required="true">
                            
                        </base-input>
                    </div>
                </el-card>
            </div>
            <div class="col-sm-5">
                <el-card>
                    <h4>Business Category</h4>
                    <div style="display:flex" >
                        <base-input label="" style="width:100%" :required="true">
                            <el-select class="select-primary" size="large" placeholder=""
                                v-model="clientType" filterable style="width:100%">
                                <!-- <el-option v-for="option in companyList" class="select-primary"
                                    :value="option.id" :label="option.name.en_US" :key="option.id">
                                </el-option> -->
                            </el-select>
                        </base-input>
                    </div>
                </el-card>
                <el-card>
                    <div style="display:flex" class="sales-title">
                        <h4>Contact Person</h4>
                        <h4 style="order:2;margin-left:auto" class="sub">
                            <span class="add-button" >
                            +
                            </span>Contact Person
                        </h4>
                        <h4 style="order:3" class="sub"><i class="tim-icons icon-single-02"></i>New Contact</h4>
                        <hr>
                    </div>
                </el-card>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <el-card>
                    <h4>Business Category</h4>
                    <div class="row">
                        <div class="col-sm-6">
                            <div style="display:flex;width:100%" class="input-with-check-box" >
                                <base-input label="Product" style="width:75%%" :required="true">
                                    <el-select class="select-primary" size="large" placeholder="Agency"
                                            v-model="clientType" filterable style="width:100%">
                                            <!-- <el-option v-for="option in companyList" class="select-primary"
                                                :value="option.id" :label="option.name.en_US" :key="option.id">
                                            </el-option> -->
                                    </el-select>
                                    <div style="display:flex; visibility:hidden" >
                                            <span class="sub-info" style="margin-left:auto;"><span class="dot"></span>4A</span>
                                            <span class="sub-info"><span class="dot"></span> 88</span>
                                    </div>
                                </base-input>
                                <base-checkbox v-model="isNewClient">New Product</base-checkbox>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <base-input label="Product Category" style="width:100%" :required="true">
                                <el-select class="select-primary" size="large" placeholder=""
                                    v-model="clientType" filterable style="width:100%">
                                    <!-- <el-option v-for="option in companyList" class="select-primary"
                                        :value="option.id" :label="option.name.en_US" :key="option.id">
                                    </el-option> -->
                                </el-select>
                            </base-input>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <el-card>
                
                    <div style="display:flex" class="sales-title" >
                        <h4>Contracts</h4>
                        <h4 class="sub" style="order: 2;line-height:32px;cursor:pointer" @click="newContract()"><span class="add-button"> + </span> New Contract</h4>
                        <h4 class="sub" style="order: 2; line-height:32px;cursor:pointer"><span class="add-button"> + </span> Installment</h4>
                    </div>
            
                    <div style="display:flex" class="input-with-check-box" >
                        <base-button type="primary">Action</base-button>
                        <!-- <base-input  style="width:47%" :required="true">
                        
                                <div class="Rectangle" >
                                    Action<i class="el-icon-arrow-down el-icon--right"></i>
                                </div>
                            
                        </base-input> -->
                    </div>
                </el-card>
            </div>
        </div>

    </div>
</template>
<script setup>
import { watch,ref } from 'vue'
import baseInput from "@/components/newUI/Inputs/BaseInput";
import baseButton from "@/components/newUI/BaseButton";
import baseCheckbox from "@/components/newUI/Inputs/BaseCheckbox";
import router from "@/router/index";

const clientType = ref('');
const isNewClient = ref(false);
const newContract = () =>{
    router.replace("/test2");
}
</script>

<style scoped>
.new-order h4{
    color:#3b291d
}
.new-order h5{
    color:#423022
}
.sales-title h4.sub{
    margin-left:54px;
    display:inline-block;
    font-size:11px
}
.sales-title i{
    position: relative;
    top: -1px;
    right: 4px;
}

.new-order .el-descriptions :not(.is-bordered) .el-descriptions-item__cell{
    padding-bottom:6px
}

.advertiser-field .form-group.has-label label::after{
    content:'【 Contracting Party 】';
    color:#d05c5f;
}
.sub-info{
    font-size:10px;
    color:#9a9a9a;
    margin-left:30px
}
.sub-info .dot{
    width: 5px;
    height: 5px;
    background-color: rgb(169, 169, 169);
    display: inline-block;
    border-radius: 50%;
    top: -1px;
    position: relative;
    right: 2px;
}

.Rectangle {
  width: 160px;
  height: 32px;
  margin: 20px 1474.6px 0 0;
  padding: 6px 15px 6px 58px;
  border-radius: 6px;
  background-image: linear-gradient(to left, #eb6100, #b60005);
  color: #fff;
}


</style>


